<div class="d-flex flex-column align-items-center w-100 gap-2 mt-5">
    <h1 class="display-1 text-primary">You have been logged out</h1>
    <div class="text-black-50">Please click below to log back in</div>
    <button routerLink="/" mat-flat-button class="text-white" color="primary">Log back
        in</button>
</div>